// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"9188deeb","787":"205be4d0"}[chunkId] + ".chunk.js";
};